import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface DropRateAnalysis {
  droppedCount: number;
  enrolledCount: number;
  id: string;
  name: string;
  classes: Array<DropRateClass>;
  totalStudents: number;
  dropRatePercentage: number;
}

export interface DropRateClass {
  classId: string;
  name: string;
  droppedCount: number;
  enrolledCount: number;
}

export interface GetDropRateAnalysisParams {
  groupBy: 'className' | 'groupName';
  sessionId: string;
}

export const getDropRateAnalysisAPI = async (
  params: GetDropRateAnalysisParams,
) => {
  const response = await baseAPI.get<Array<DropRateAnalysis>>(
    `/dashboard/drop-rate-analysis/${params.sessionId}`,
    {
      params: {
        groupBy: params.groupBy,
      },
    },
  );
  return response.data;
};

export const getDropRateAnalysisQueryOptions = (
  params: GetDropRateAnalysisParams,
) =>
  queryOptions({
    queryKey: QUERY_KEYS.DROP_RATE_ANALYSIS({
      sessionId: params.sessionId,
      groupBy: params.groupBy,
    }),
    queryFn: () => getDropRateAnalysisAPI(params),
  });

export const useGetDropRateAnalysis = (params: GetDropRateAnalysisParams) => {
  return useQuery(getDropRateAnalysisQueryOptions(params));
};
